const chatMessage = {
  title: 'Click.AI',
  helpPrompt: {
    title: '¿Cómo puedo ayudarte hoy?',
    firstSteps: 'Guía de primeros pasos',
    model: '¿Cómo crear un modelo?',
  },
  footer: {
    input: {
      placeholder: 'Habla con Click.AI',
    },
    help: {
      text: '¿Aún tienes dudas? Visita nuestra',
      link: 'Central de Ayuda',
    },
  },
};

export default chatMessage;
